import { Box, Divider, List, ListIcon, ListItem, OrderedList, SimpleGrid, Text } from '@chakra-ui/react'
import { CheckCircleIcon, CheckIcon, ChevronRightIcon, MdCheckCircle } from '@chakra-ui/icons'
import React from 'react'
import NotAvailable from './NotAvailable'

const Summary = ({ Summary }) => {
    console.log(Summary)
    return (
        <>
            <Box p="2" display="flex" justifyContent="space-between">
                <Text fontSize='lg' color="gray.500" display="flex" justifyContent="start" alignItems="center" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 2048 2048"><path fill="currentColor" d="M2048 384v1024h-128V839l-640 321v120H768v-120L128 839v697h1152v128H0V384h640V256q0-27 10-50t27-40t41-28t50-10h512q27 0 50 10t40 27t28 41t10 50v128h640zm-1280 0h512V256H768v128zm384 640H896v128h256v-128zm768-327V512H128v185l640 319V896h512v120l640-319zm-128 839h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" /></svg>
                    <span style={{ marginLeft: "5px" }}>Total years of experience</span>
                </Text>
                <Text fontSize='5xl' color='blue.500'>{Summary['yoe'] ? Summary['yoe'] : <NotAvailable />}</Text>
            </Box>
            <Divider />
            <Box>
                <Text p="2" display="flex" justifyContent="start" alignItems="center" color="gray.500" fontSize="lg" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><path fill="currentColor" d="M119.1 25v.1c-25 3.2-47.1 32-47.1 68.8c0 20.4 7.1 38.4 17.5 50.9L99.7 157L84 159.9c-13.7 2.6-23.8 9.9-32.2 21.5c-8.5 11.5-14.9 27.5-19.4 45.8c-8.2 33.6-9.9 74.7-10.1 110.5h44l11.9 158.4h96.3L185 337.7h41.9c0-36.2-.3-77.8-7.8-111.7c-4-18.5-10.2-34.4-18.7-45.9c-8.6-11.4-19.2-18.7-34.5-21l-16-2.5L160 144c10-12.5 16.7-30.2 16.7-50.1c0-39.2-24.8-68.8-52.4-68.8c-2.9 0-4.7-.1-5.2-.1zM440 33c-17.2 0-31 13.77-31 31s13.8 31 31 31s31-13.77 31-31s-13.8-31-31-31zM311 55v48H208v18h103v158h-55v18h55v110H208v18h103v32h80.8c-.5-2.9-.8-5.9-.8-9c0-3.1.3-6.1.8-9H329V297h62.8c-.5-2.9-.8-5.9-.8-9c0-3.1.3-6.1.8-9H329V73h62.8c-.5-2.92-.8-5.93-.8-9c0-3.07.3-6.08.8-9H311zm129 202c-17.2 0-31 13.8-31 31s13.8 31 31 31s31-13.8 31-31s-13.8-31-31-31zm0 160c-17.2 0-31 13.8-31 31s13.8 31 31 31s31-13.8 31-31s-13.8-31-31-31z" /></svg>
                    <span style={{ marginLeft: "3px" }}>Skills</span>
                </Text>
                <Divider />
                <List spacing={3} p="4">
                    <SimpleGrid columns={3} spacing={1}>
                        {
                            Summary.skills.lenght === 0 ? <NotAvailable /> :
                                Summary.skills.map((skill, index) => <ListItem maxWidth="260px" key={index}><ListIcon as={CheckIcon} color='blue.500' /> {skill}</ListItem>)
                        }
                    </SimpleGrid>
                    {/* {
                        Summary.skills.lenght === 0 ? <NotAvailable /> :
                            Summary.skills.map((skill, index) => <ListItem key={index}>{skill}</ListItem>)
                    } */}
                </List>
            </Box>
        </>
    )
}

export default Summary